import { WorkflowType } from "./workflow";

export class ExternalDataSource {
  type: string;
  key: string;
  label: string;
  canEditExternalValueDefault: boolean;
  sourceConfig: ExternalDataSourceConfig;
}

export class ExternalDataSourceTypeCodes {
  parcelSearchEDStypeCode: string;
  registrationEDStypeCode: string;
  contractorRegistrationEDStypeCode: string;
  applicantDataEDStypeCode: string;
  customListEDStypeCode: string;

  constructor() {
    let parcelSearchExternalSourceObj: ParcelSearchExternalSource = new ParcelSearchExternalSource();
    let registrationExternalSourceObj: RegistrationExternalSource = new RegistrationExternalSource();
    let contractorRegistrationExternalSourceObj: ContractorRegistrationExternalSource = new ContractorRegistrationExternalSource();
    let applicantDataExternalSourceObj: ApplicantDataExternalSource = new ApplicantDataExternalSource();
    let customListExternalSourceObj: CustomListExternalSource = new CustomListExternalSource();

    this.parcelSearchEDStypeCode = parcelSearchExternalSourceObj.type;
    this.registrationEDStypeCode = registrationExternalSourceObj.type;
    this.contractorRegistrationEDStypeCode = contractorRegistrationExternalSourceObj.type;
    this.applicantDataEDStypeCode = applicantDataExternalSourceObj.type;
    this.customListEDStypeCode = customListExternalSourceObj.type;

    parcelSearchExternalSourceObj = null;
    registrationExternalSourceObj = null;
    contractorRegistrationExternalSourceObj = null;
    applicantDataExternalSourceObj = null;
    customListExternalSourceObj = null;
  }
}

export class ExternalDataSourceConfig {}

export class ParcelSearchExternalSource extends ExternalDataSource {
  constructor() {
    super();

    this.type = 'parcel-search-external-source';
  }
}

export class ParcelSearchExternalSourceConfig extends ExternalDataSourceConfig {
  type: string;
  options: ParcelSearchExternalSourceOption[];
  selectedOption: ParcelSearchExternalSourceOption;
}

export class ParcelSearchExternalSourceOption {
  parcelSearchActivityId: string;
  fieldName: string;
  fieldAlias: string;
}

export class RegistrationExternalSource extends ExternalDataSource {
  constructor() {
    super();

    this.type = 'registration-external-source';
  }
}

export class RegistrationExternalSourceConfig extends ExternalDataSourceConfig {
  type: string;
  options: RegistrationExternalSourceOption[];
  selectedMappings: RegistrationExternalSourceSelectedMappings;
}

export class RegistrationExternalSourceOption {
  isThisWorkflow: boolean;
  sourceWorkflowId: string;
  sourceWorkflowDraftVersionId: string;
  sourceWorkflowDraftVersionName: string;
}

export class RegistrationExternalSourceSelectedMappings {
  mapFromThisWorkflow: boolean;
  otherWorkflowMappings: RegistrationExternalSourceMapping[];

  public constructor(
    options?: Partial<RegistrationExternalSourceSelectedMappings>
  ) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class RegistrationExternalSourceMapping {
  sourceWorkflowId: string;
  fieldTemplateCode: string;

  public constructor(options?: Partial<RegistrationExternalSourceMapping>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class ContractorRegistrationExternalSource extends ExternalDataSource {
  constructor() {
    super();

    this.type = 'contractor-registration-external-source';
  }
}

export class ContractorRegistrationExternalSourceConfig extends ExternalDataSourceConfig {
  type: string;
  options: ContractorRegistrationExternalSourceOption[];
  selectedMappings: ContractorRegistrationExternalSourceSelectedMappings;
}

export class ContractorRegistrationExternalSourceOption {
  contractorTypeId: string;
  contractorTypeName: string;
  contractorWorkflowType: WorkflowType;
  sourceWorkflowId: string;
  sourceWorkflowDraftVersionId: string;
}

export class ContractorRegistrationExternalSourceSelectedMappings {
  mapFromThisWorkflow: boolean;
  registerWorkflowId: string;
  registerWorkflowFieldTemplateCode: string;

  public constructor(
    options?: Partial<ContractorRegistrationExternalSourceSelectedMappings>
  ) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class ApplicantDataExternalSource extends ExternalDataSource {
  constructor() {
    super();

    this.type = 'applicant-data-external-source';
  }
}

export class ApplicantDataExternalSourceConfig extends ExternalDataSourceConfig {
  type: string;
  options: ApplicantDataExternalSourceOption[];
  selectedOption: ApplicantDataExternalSourceOption;
}

export class ApplicantDataExternalSourceOption {
  requireUserActivityId: string;
  templateCode: string;
  label: string;
}

export class CustomListExternalSource extends ExternalDataSource {
  constructor() {
    super();

    this.type = 'custom-list-external-source';
  }
}

export class CustomListExternalSourceConfig extends ExternalDataSourceConfig {
  type: string;
  options: CustomListExternalSourceOption[];
  selectedOption: CustomListExternalSourceOption;
}

export class CustomListExternalSourceOption {
  listDataEntityId: string;
  listDataEntityTemplateCode: string;
  listDataEntityLabel: string;
  customListId: string;
  customListName: string;
  attributeId: string;
  attributeName: string;
}
